import { AnalysisStoreProvider } from '@modules/analysis/store/AnalysisStoreProvider';
import { QuantifyStoreProvider } from '@modules/quantify/store/QuantifyStoreProvider';
import { QueryBuilderStoreProvider } from '@modules/queryBuilder/store/QueryBuilderStoreProvider';
import { AnalysisUseCase } from 'generated/graphql';

interface OracleQuantifyProviderProps {
  children: React.ReactNode;
}

export function OracleQuantifyProvider({
  children,
}: OracleQuantifyProviderProps) {
  return (
    <AnalysisStoreProvider useCase={AnalysisUseCase.Default}>
      <QuantifyStoreProvider>
        <QueryBuilderStoreProvider>{children}</QueryBuilderStoreProvider>
      </QuantifyStoreProvider>
    </AnalysisStoreProvider>
  );
}
